module.exports = __webpack_public_path__ + "static/media/checkThick-16.7e43d0d7.svg";